import React, { useState, FunctionComponent } from 'react';
import { FaCircleInfo } from 'react-icons/fa6';
import { InfoIconPopupProps } from './types';

export const InfoIconPopup: FunctionComponent<InfoIconPopupProps> = ({
  children,
  size = 20,
  openTo = 'right',
  width = 420,
  title,
  opacity,
}) => {
  const [isActive, setActive] = useState(false);

  const toggleClass = () => {
    setActive(!isActive);
  };

  return (
    <>
      <div
        className={isActive ? 'dropdown opened' : 'dropdown'}
        style={{ marginRight: 'auto' }}
        onMouseEnter={toggleClass}
        onMouseLeave={toggleClass}
      >
        <div style={{ paddingLeft: '5px', lineHeight: 0 }} title={title} aria-label={title}>
          <FaCircleInfo size={size} color="var(--theme-primary-color)" opacity={opacity} />
        </div>
        <div className={`dropdown-menu max-h320${openTo === 'left' ? ' drop-right' : ''}`} style={{ minWidth: width }}>
          <div className="mini-popup">
            <div className="mini-popup-body">
              <div style={{ fontWeight: 'normal', fontSize: 14, lineHeight: 1.45 }}>{children}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
